export const permissionToPath = (permission: string): string => {
  const splittedPermission = permission.split('::');
  if (splittedPermission.length > 1) {
    const path = splittedPermission.join('.');
    return path;
  }
  return permission;
};
